import Vue from 'vue'
// import mqtt from 'mqtt'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import animated from 'animate.css'
import scroll from 'vue-seamless-scroll'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(animated)
Vue.use(scroll)

// const service = Axios.create({
//   baseURL: _CONFIG['baseApi'],
//   timeout: 5000,
// });

// Vue.prototype.$http = service;

// service.interceptors.response.use(
//   response =>{
//     return response
//   },
//   error => {
//     router.push("/500")
//   }
// );

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh-CN',   
  //this.$i18n.locale 
  messages: {
    'zh-CN': require('./common/lang/zh'),   
    'en-US': require('./common/lang/en'),  
    'hu-HU': require('./common/lang/hu'),    
    'fr-FR': require('./common/lang/fr'),  
    'de-DE': require('./common/lang/de')  
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js